import React, { Component } from "react";
import Helmet from "react-helmet";

import avatar from '../static/avatar.jpg'
import Container from "../components/container";
import Footer from "../components/footer";
import Header from "../components/header";
import TimelineFacts from "../components/maptimeline";
import favicon from "../favicon.png";
import styles from "./index.module.css";

const AboutSection = props => (
  <section className={styles.about}>
    <img className={styles.avatar} src={avatar} alt="" />
    <div className={styles.description}>
      <h2 className={styles.ribbon}>
        {props.title}{" "}
        <span style={{ position: "relative", top: "2px", left: "-1px" }}>
          ¯\_(ツ)_/¯
        </span>
      </h2>
      <p className={styles.excerpt}>
        I'm a minimalist and a developer happily living in Toronto, ON. I am
        currently a Software Engineer at{" "}
        <a href="https://www.intelex.com">Intelex</a>, previously a Software
        Engineer Intern at <a href="https://www.wisewear.com">WiseWear</a>. You
        can find me away from home climbing rocks, finding cheap flights to
        uncharted destinations, or coding projects that are unconventionally
        challenging.
      </p>
    </div>
  </section>
);

export default class extends Component {
  render() {
    return (
      <div>
        <Helmet title="Bryan's Portfolio">
          <meta property="og:title" content="Portfolio of Bryan Deloeste" />
          <meta property="og:image" content={favicon} />
          <meta property="og:url" content="https://deloeste.xyz" />
        </Helmet>
        <Container>
          <Header />
          <AboutSection title="Hi, I'm Bryan" />
          <TimelineFacts />
          <Footer />
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js